import React from 'react'
import { NavbarTwo } from '../components/Layout/Navbar'
import Banner from '../components/Home/Banner'
import WhatWeDo from '../components/Home/WhatWeDo'
import Sectors from '../components/Home/Sectors'
import AboutHome from '../components/Home/AboutHome'
import OurProducts from '../components/Home/OurProducts'
import OurReleases from '../components/Home/OurReleases'
import HomeCta from '../components/Home/HomeCta'
import Testimonial from '../components/Home/Testimonial'
import Footer from '../components/Layout/Footer'

const Home = () => {
  return (
    <div>
        <NavbarTwo />
        <div className='2xl:pt-[90px] pt-[50px] xl:pt-[80px] lg:pt-[70px]'>
        <Banner />
        <WhatWeDo />
        <Sectors />
        <AboutHome />
        <OurProducts />
        <OurReleases />
        <Testimonial />
        <HomeCta />
        <Footer />
        </div>
    </div>
  )
}

export default Home
